import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.48 11.616l7.63 1.388a1.1 1.1 0 0 1 .886.885l1.388 7.631L19.62 4.38 2.48 11.616zm-1.935-.268l19.821-8.37a.5.5 0 0 1 .655.656l-8.369 19.82a.5.5 0 0 1-.952-.104l-1.688-9.282a.1.1 0 0 0-.08-.08L.65 12.3a.5.5 0 0 1-.105-.952z"
});

var SvgLocationCurrent = function SvgLocationCurrent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgLocationCurrent;